import config from './config.json';

export interface GameConfig {
  name: string;
  archiveName: string;
  defaultHeroId: string;
  logo?: string;
  filters: { key: string; label: string; traitLabels?: string[]; source?: 'stars' }[];
}
export const games = config as Record<string, GameConfig>;
